import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sendMessage" }
const _hoisted_2 = { class: "formMessage" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_send" }, null, -1)
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_TE_pic" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_pointer" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-4 w-6rem mr-0 relative"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "verificationStatus" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1)
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "w-30rem h-30rem mt-5" }
const _hoisted_13 = { class: "p-float-label flex justify-items-between padding" }
const _hoisted_14 = { class: "flex w-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_pointer w-1 text-2xl border-none inline-flex align-items-center justify-content-center text-primary-500" }, null, -1)
const _hoisted_16 = { class: "formMessage mt-6 w-30rem flex justify-items-between" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_InputText, {
          id: "firstName",
          type: "text",
          modelValue: _ctx.message,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
          name: "firstName"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Button, {
          onClick: _ctx.sendMessage,
          disabled: _ctx.message?.trim().length === 0 && !_ctx.selectedImage
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          ref: "imageUpload",
          "hide-input": "",
          accept: "image/*",
          style: {"display":"none"},
          type: "file",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args)))
        }, null, 544),
        _createVNode(_component_Button, {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openUploadImage()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.locationVisible = true))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        (_ctx.selectedImage !== null || _ctx.location.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                class: "w-6rem h-auto",
                src: _ctx.selectedImage?.toString() || _ctx.location.value?.toString(),
                alt: "Attachment thumbnail"
              }, null, 8, _hoisted_8),
              _createElementVNode("button", {
                class: "absolute top-0 right-0 surface-300 flex align-items-center justify-content-center w-1rem h-1rem border-circle icon-warpit_icon_close_small text-sm mr-0",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearData && _ctx.clearData(...args)))
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    _createVNode(_component_Dialog, {
      visible: _ctx.showErrorDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showErrorDialog) = $event)),
      class: "successDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("feedback.invalid_image")), 1)
        ]),
        _createElementVNode("button", {
          class: "defaultButton",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showErrorDialog = false))
        }, _toDisplayString(_ctx.$t("dialog.close")), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.locationVisible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.locationVisible) = $event)),
      showHeader: false,
      onHide: _cache[13] || (_cache[13] = ($event: any) => (_ctx.locationVisible = false)),
      closable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "icon-warpit_icon_arrow-L w-1 border-none bg-transparent text-primary-500 cursor-pointer",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetLocation && _ctx.resetLocation(...args)))
            }),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_GMapAutocomplete, {
                class: "text-base shadow-none outline-none border-none border-bottom-1 flex-grow-1 h-full pac-container w-10 padding flex-grow",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedLocation.text = $event.target.value)),
                onPlace_changed: _ctx.setAddress,
                options: {
                componentRestrictions: { country: 'si' },
              },
                value: _ctx.selectedLocation.text,
                placeholder: "",
                id: "location",
                maxlength: "255"
              }, null, 8, ["onPlace_changed", "value"])
            ]),
            _hoisted_15
          ]),
          _createVNode(_component_GMapMap, {
            zoom: 15,
            center: _ctx.center,
            onClick: _ctx.handleMapClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GMapMarker, {
                position: _ctx.marker.position
              }, null, 8, ["position"])
            ]),
            _: 1
          }, 8, ["center", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            id: "firstName",
            type: "text",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedLocation.text) = $event)),
            name: "firstName",
            class: "w-11 styled-input shadow-none outline-none border-bottom-1 border-none text-base"
          }, null, 512), [
            [_vModelText, _ctx.selectedLocation.text]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "icon-warpit_icon_check-round text-3xl border-none p-0 cursor-pointer bg-transparent inline-flex align-items-center justify-content-center text-primary-500 ml-2",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.selectLocation && _ctx.selectLocation(...args))),
            disabled: _ctx.selectedLocation.text?.trim().length === undefined
          }, null, 8, _hoisted_17)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}